export default {
    url: '/add',
    template: `
        <user-tasklist-add
            tasklist="vm.tasklist"
            tasklist-templates="vm.tasklistTemplates"
            classifiers="vm.classifiers"
        />`,
    resolve: {
        tasklistTemplates (TasklistTemplateResource) {
            return TasklistTemplateResource.query({ expand: 'templateTasks.file' }).$promise;
        },
        classifiers: ClassifierResource => ClassifierResource.query({ pageSize: 0 }).$promise
    },
    controller (TasklistResource, tasklistTemplates, classifiers) {
        this.tasklist = new TasklistResource();
        this.tasklistTemplates = tasklistTemplates;
        this.classifiers = classifiers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/tasklist/add/index.js